
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(023|236|77)|(5|66)11|1249|1313|3170|3999|6967|7256|9598)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
